import { CSSProperties } from 'react';

export const styles = {
  container: {
  } as CSSProperties,

  header: {
    fontSize: 16,
    fontWeight: 600,
    marginBottom: 4,
  } as CSSProperties,

  description: {
    color: '#666',
    fontSize: 13,
    marginBottom: 24,
  } as CSSProperties,

  previewContainer: {
    marginBottom: 16,
  } as CSSProperties,

  previewImage: {
    maxWidth: '300px',
    maxHeight: '150px',
    border: '1px solid #d9d9d9',
    borderRadius: 4,
    padding: 8,
  } as CSSProperties,

  buttonContainer: {
    display: 'flex',
    gap: 12,
    alignItems: 'center',
  } as CSSProperties,

  saveHint: {
    marginTop: 8,
    fontSize: 12,
    color: '#999',
  } as CSSProperties,
};
